import { inject, Injectable } from '@angular/core';
import { AdministrationHttpClient } from '../../administration-http-client';
import { Observable } from 'rxjs';
import { ClientFeatures } from '../../modules/solvace-customer/models/client-features.interface';

@Injectable({
  providedIn: 'root',
})
export class AdmClienteFeatureService {
  #http = inject(AdministrationHttpClient);

  public getTreeTable(params?: any): Observable<ClientFeatures[]> {
    return this.#http.get<ClientFeatures[]>('/ClientFuncionality', { params: params });
  }

  public putClientFuncionality(params: ClientFeatures): Observable<boolean> {
    return this.#http.put<boolean>('/ClientFuncionality', { parameters: [params] });
  }
}
